<template>
  <modelframe :message="message">
    <el-row style="margin:100px 0 50px ">
      <el-col :span="11" :push="1" >
          <my-chart type="bar"
                    chart-title="活跃用户数量"
                    :chart-data="countData"
                    :width="chartConfig.width"
                    :height="chartConfig.height"
                    :border="chartConfig.border"
                    :bar-width-scale="chartConfig.scale"
          />
      </el-col>
      <el-col :span="11" style="margin-left:45px">
        <my-chart type="pie"
                  chart-title="活跃用户比例"
                  :chart-data="radioData"
                  :width="chartConfig.width"
                  :height="chartConfig.height"
                  :border="chartConfig.border"
                  :bar-width-scale="chartConfig.scale"
        />
      </el-col>
    </el-row>
  </modelframe>
</template>

<script>
import MyChart from "@/components/myChart";
export default {
  name: "analysis",
  components: {MyChart},
  data(){
    return {
      countData:[],
      radioData:[],
      chartConfig:{
        type:'pie',//图表类型
        width:500,//图标宽度 400
        height:400,//图表高度 320
        border:true,//有无边框
        scale:'50%'//柱状图宽度比例
      },
      message:{
        code:0,
        msg:'',
      }

    }
  },
  methods:{
    setMessage(code,msg){
      this.message.code =code;
      this.message.msg =msg;
    },
    initData(data){
      console.log('开始初始化数据');
      Object.entries(data['loginUserCount']).forEach(entry=>{
        let name = '';
        switch (entry[0]){
          case 'monthCount':
            name = '一月内'
            break;
          case 'weekCount':
            name = '一周内'
            break;
          case 'dayCount':
            name = '一天内'
            break;
        }
        this.countData.push({name:name,value:entry[1]});
      });
      console.log(JSON.stringify(this.countData));
      Object.entries(data['loginUserCountRatio']).forEach(entry=>{
        let name = '';
        switch (entry[0]){
          case 'monthCount':
            name = '一月内'
            break;
          case 'weekCount':
            name = '一周内'
            break;
          case 'dayCount':
            name = '一天内'
            break;
        }
        this.radioData.push({name:name,value:entry[1]});
      });
      console.log(JSON.stringify(this.radioData));
    },//初始化图表的数据
    getData(){
      this.setMessage(1);
      this.axios.post('http://101.133.156.109:81/api/Statistic/statistics').then((res)=>{
        if (res.status){
          this.initData(res.data.data);
          this.setMessage(0);
        }else{
          this.setMessage(-1,res.data.msg);
        }
      }).catch(error => this.setMessage(-1,"加载失败，错误信息："+error));
    },//发出url请求初始化图表
  },
  computed:{
    chartType(){
      let type = this.$route.query.type;
      return type
    }
  },
  watch:{
    chartType:{
      immediate:true,
      handler(){
        this.getData();
      }
    }
  }
}
</script>

<style scoped>

</style>
